import { IPalletEdited } from '../types/palletItem';
import { IPalletDetailes } from '../../../../../modules/API/Pallets/models/palletList';

/** Sets isSelected on the first pallet with this number; not found — the same list. */
export const setPalletSelected = (
    list: IPalletEdited[] | null,
    palletNum: number,
    isSelected: boolean,
): IPalletEdited[] | null => {
    if (!list) return list;
    const idx = list.findIndex((item) => item.Pallet_Num === palletNum);
    if (idx === -1) return list;
    const next = list.slice();
    next[idx] = { ...list[idx], isSelected };
    return next;
};

export const removePalletDetail = (
    list: IPalletEdited[] | null,
    palletNum: number,
    recID: number,
): IPalletEdited[] | null =>
    list &&
    list.map((item) =>
        item.Pallet_Num === palletNum
            ? { ...item, Details: item.Details.filter((e) => e.RecID !== recID) }
            : item,
    );

export const prependPalletDetail = (
    list: IPalletEdited[] | null,
    palletNum: number,
    detail: IPalletDetailes,
): IPalletEdited[] | null =>
    list &&
    list.map((item) =>
        item.Pallet_Num === palletNum ? { ...item, Details: [detail, ...item.Details] } : item,
    );

export const togglePalletExpanded = (
    expanded: ReadonlySet<number>,
    palletNum: number,
): ReadonlySet<number> => {
    const next = new Set(expanded);
    if (next.has(palletNum)) next.delete(palletNum);
    else next.add(palletNum);
    return next;
};
